<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="custom-shadow-card-header">
          <div class="row content-add-btn">
            <div class="col-4" v-if="isCreate()">
              <div class="text-left">
                <button
                  class="btn btn-secondary custom-shadow-btn"
                  @click="$router.push('/modules/create')"
                >
                  <em class="fa fa-plus"></em>
                  {{ $t('common_words.add_module') }}
                </button>
              </div>
            </div>
            <div class="col-12 text-center">
              <hr />
            </div>
            <el-dialog
              v-if="isShow()"
              :title="titleModal"
              :visible.sync="modals.read"
              top="2%"
            >
              <p>
                {{ $t('common_words.selected_record_info') }}
              </p>
              <div class="card" v-if="rowData">
                <div class="card-body" v-if="rowData">
                  <table class="table">
                    <tbody v-if="rowData">
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.name') }}</strong>
                          </h6>
                          {{ rowData.name }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6><strong>URL</strong></h6>
                          {{ rowData.url }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.icon') }}</strong>
                          </h6>
                          {{ rowData.icon }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{
                              $t('common_words.description')
                            }}</strong>
                          </h6>
                          {{ rowData.description }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{
                              $t('common_words.order_request')
                            }}</strong>
                          </h6>
                          {{ $t('common_words.order') }} {{ rowData.order }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.level') }}</strong>
                          </h6>
                          {{ $t('common_words.level') }} {{ rowData.level }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong
                              >{{
                                $t('common_words.associated_crops')
                              }}:</strong
                            >
                          </h6>
                          <span
                            v-for="(item, index) in rowData.crops"
                            :key="index"
                          >
                            <el-tag type="info">{{ item.name }}</el-tag>
                          </span>
                          <el-tag
                            type="warning"
                            v-if="rowData.crops.length == 0"
                            >{{
                              $t('common_words.no_associated_crops')
                            }}</el-tag
                          >
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{
                              $t('common_words.parent_module')
                            }}</strong>
                          </h6>
                          <el-tag type="info" v-if="rowData.parent_label">{{
                            rowData.parent_label
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.value') }}</strong>
                          </h6>
                          {{ rowData.other_value }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{ $t('common_words.profile') }}</strong>
                          </h6>
                          {{ rowData.roles_names }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{
                              $t('common_words.own_permissions')
                            }}</strong>
                          </h6>
                          <el-tag
                            :key="tag"
                            v-for="tag in rowData.own_permissions"
                            type="info"
                            :disable-transitions="false"
                          >
                            {{ tag }}
                          </el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="mb-2">
                            <strong>{{ $t('common_words.manuals') }}:</strong>
                          </h6>
                          <template>
                            <div>
                              <template v-if="isSet(rowData.manual_path)">
                                <a
                                  style="cursor: pointer"
                                  v-for="(file, index) in rowData.fileList"
                                  :key="index"
                                  @click="
                                    handleDownload(rowData.manual_path, file)
                                  "
                                >
                                  <el-tag type="info">
                                    <em class="fa fa-solid fa-download"></em>
                                    {{ file }}
                                  </el-tag>
                                </a>
                              </template>
                              <el-tag type="warning" v-else>{{
                                $t('common_words.no_assigned')
                              }}</el-tag>
                            </div>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer footer-date-at" v-if="rowData">
                  <p class="text-muted">
                    <small
                      >{{ $t('common_words.created_on') }}:
                      {{ rowData.created_at }}</small
                    >
                  </p>
                </div>
              </div>
            </el-dialog>
            <el-dialog :title="titleModal" :visible.sync="modals.roles">
              <span>
                {{ $t('common_words.select_associated_module_profiles') }}</span
              ><br /><br />
              <el-select
                @change="selectAllFromSelect('moduleForm.roles', roles)"
                clearable
                multiple
                class="select-primary custom-width-select shadow-sm required-rol"
                v-model="moduleForm.roles"
                filterable
                :placeholder="$t('common_words.select_one_or_many_profiles')"
              >
                <el-option
                  v-for="option in roles"
                  class="select-primary selected-all"
                  :value="option.id"
                  :label="option.name"
                  :key="option.name"
                >
                </el-option>
              </el-select>
              <span slot="footer" class="dialog-footer">
                <button class="btn btn-danger" @click="closeModal('roles')">
                  {{ $t('common_words.cancel') }}</button
                >&nbsp;
                <button class="btn btn-success" @click="addOrDeleteRol()">
                  {{ $t('common_words.confirm') }}
                </button>
              </span>
            </el-dialog>
          </div>
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                filterable
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                :data="queriedData"
                max-height="530"
                style="width: 100%"
                :border="true"
              >
                <el-table-column
                  type="index"
                  width="80"
                  :align="'center'"
                  :resizable="false"
                ></el-table-column>
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  :fixed="column.fixed"
                  :sortable="column.sortable"
                  :align="column.align"
                  :resizable="false"
                >
                </el-table-column>

                <table-column-badges
                  :label="$t('common_words.associated_crops')"
                  :minWidth="120"
                  fromData="crops"
                  textBadge="name"
                />

                <el-table-column
                  :min-width="120"
                  fixed="right"
                  :label="$t('common_words.actions')"
                  :align="'center'"
                  :resizable="false"
                >
                  <template slot-scope="props">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye"></em
                    ></a>
                    <a
                      v-if="isManagementRole()"
                      v-tooltip.top-center="
                        $t('common_words.associate_profiles')
                      "
                      class="btn-success btn-simple btn-link"
                      @click="handleRoles(props.$index, props.row)"
                      ><em class="fa fa-tags"></em
                    ></a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link"
                      @click="handleEdit(props.$index, props.row)"
                      ><em class="fa fa-edit"></em
                    ></a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link"
                      @click="handleDelete(props.$index, props.row)"
                      ><em class="fa fa-times"></em
                    ></a>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            >
            </l-pagination>
          </div>
        </card>
      </div>
    </div>
    <div class="row" style="padding-right: 13px; padding-left: 13px">
      <div class="col-6" v-if="isPDF()">
        <div class="text-right">
          <button class="btn btn-danger custom-shadow-btn" @click="exportToPDF">
            <em class="fa fa-file-pdf-o"></em>
            {{ $t('common_words.export_to_pdf') }}
          </button>
        </div>
      </div>
      <div class="col-6" v-if="isExcel()">
        <div class="text-left">
          <button
            class="btn custom-btn-success custom-shadow-btn"
            @click="exportToExcel"
          >
            <em class="fa fa-file-excel-o"></em>
            {{ $t('common_words.export_to_excel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { DISK_URL } from 'src/util/Util';
import { isset } from 'src/util/Util.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { Pagination as LPagination } from 'src/components/index';
import axios from 'axios';
import configTable from './moduleTable';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    LPagination,
  },
  computed: configTable.search,
  data() {
    return {
      moduleForm: {
        name: null,
        url: null,
        icon: null,
        description: null,
        order: null,
        level: null,
        parent_module: null,
        other_value: null,
        roles: null,
      },

      titleModal: null,
      Table: {},
      Search: {},
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
        delete: false,
        roles: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      roles: null,
      fuseSearch: null,
    };
  },

  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinNotification,
    MixinExport,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.roles = this.concatAll(this.roles.splice(1));
    },
    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    handleView(index, row) {
      this.rowData = Object.assign({}, row);
      this.titleModal = i18n.t('common_words.module') + ' ' + this.rowData.name;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      row.url_path_form = '/modules/edit';
      this.moduleForm = Object.assign({}, row);
      this.moduleForm.roles = row.roles_ids;
      sessionStorage.setItem('editForm', JSON.stringify(this.moduleForm));
      this.$router.push({ path: 'modules/edit' });
    },

    handleRoles(index, row) {
      this.moduleForm = Object.assign({}, row);
      this.moduleForm.roles = row.roles_ids;
      this.titleModal = i18n.t('common_words.manage_profile_of') + row.name;
      this.modals['roles'] = true;
    },

    handleDelete(index, row) {
      this.moduleForm = Object.assign({}, row);
      this.moduleForm.roles = row.roles_ids;
      SweetAlert.delete(
        i18n.t('common_words.the_module') + this.moduleForm.name
      ).then((result) => {
        if (result.value) this.deleteModule();
      });
    },

    deleteModule() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.moduleForm.route = i18n.t('common_words.modules');
        Axios.destroyMaster(this.moduleForm)
          .then((response) => {
            this.modifyTable(2, this.moduleForm.id, response);
            this.forceRenderMenu();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    addOrDeleteRol() {
      if (this.moduleForm.roles.length == 0) {
        for (let index of document.getElementsByClassName('required-rol')) {
          let sel = index.getElementsByClassName('el-input__inner')[0];
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
        }
      } else {
        this.showHideLoading(true);
        axios
          .post('auth/modules/rol', this.moduleForm)
          .then((response) => {
            this.closeModal('roles');
            let index = this.tableData.findIndex(
              (tableRow) => tableRow.id === this.moduleForm.id
            );
            this.$set(this.tableData, index, response.data.data);
            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-cloud-download-93',
              `${i18n.t('common_words.success_operation')}...`
            );
            this.showHideLoading();
            this.forceRenderMenu();
          })
          .catch((error) => {
            this.closeModal('roles');
            this.showMessageErrors(error);
          });
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'modules/pdf';
      data.name_file = `${i18n.t('common_words.modules')}.pdf`;
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      let data = {};
      data.route = 'modules/excel';
      data.name_file = `${i18n.t('common_words.modules')}.xlsx`;
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    setupTable() {
      const { Table, Search } = configTable();
      this.Table = Table;
      this.Search = Search;
      this.tableColumns = Table.tableColumns;
      this.pagination = Table.pagination;
    },

    isSet(data) {
      return isset(data);
    },

    handleDownload(folder, fileName) {
      const diskName = 'module_manuals';
      const url = `${DISK_URL}${diskName}/${folder}/${encodeURIComponent(
        fileName
      )}`;
      window.open(url, '_blank');
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('modules')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });

          Axios.getMasters('roles/indexfield')
            .then((response1) => {
              this.roles = this.concatAll(response1.data.data);
              this.showHideLoading();
            })
            .catch((error) => {
              this.showHideLoading();
              SweetAlert.warning(error.response.data.message);
            });
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('modules');
  },

  destroyed() {
    this.deselectedItemOnMenu('modules');
  },
};
</script>
<style></style>
